/**
 * Admin Action Types
 * Centralized action type constants for the admin reducer
 *
 * Naming convention: DOMAIN/ACTION_NAME
 * This prevents collisions with other reducers and makes debugging easier
 */

// Form management actions
export const SET_SUBMITTED_FORMS = 'admin/SET_SUBMITTED_FORMS';
export const SET_PAGINATED_FORMS = 'admin/SET_PAGINATED_FORMS';
export const SET_FORM_LOADING = 'admin/SET_FORM_LOADING';
export const SET_RECENT_FORMS = 'admin/SET_RECENT_FORMS';

// User management actions
export const GET_PORTAL_USERS = 'admin/GET_PORTAL_USERS';
export const PORTAL_USER_LOADING = 'admin/PORTAL_USER_LOADING';
export const SET_PORTAL_USER = 'admin/SET_PORTAL_USER';

// Form submission actions
export const FORM_SUBMISSION = 'admin/FORM_SUBMISSION';
export const FORM_UPDATE_SUCCESS = 'admin/FORM_UPDATE_SUCCESS';
export const FORM_UPDATE_FAILURE = 'admin/FORM_UPDATE_FAILURE';

// Error handling
export const ERROR_STATES = 'admin/ERROR_STATES';
export const CLEAR_ERRORS = 'admin/CLEAR_ERRORS';

// Session management actions
export const SET_ACTIVE_SESSIONS = 'admin/SET_ACTIVE_SESSIONS';
export const SET_SESSION_STATS = 'admin/SET_SESSION_STATS';
export const SET_SESSION_LOADING = 'admin/SET_SESSION_LOADING';

// Security actions
export const SET_SECURITY_METRICS = 'admin/SET_SECURITY_METRICS';
export const SET_SECURITY_LOADING = 'admin/SET_SECURITY_LOADING';

// Auth actions
export const GET_LOGOUT = 'admin/GET_LOGOUT';

/**
 * All admin action types as a frozen object
 * Use this for type checking and IDE autocomplete
 */
export const ADMIN_ACTIONS = Object.freeze({
  // Forms
  SET_SUBMITTED_FORMS,
  SET_PAGINATED_FORMS,
  SET_FORM_LOADING,
  SET_RECENT_FORMS,

  // Users
  GET_PORTAL_USERS,
  PORTAL_USER_LOADING,
  SET_PORTAL_USER,

  // Form submission
  FORM_SUBMISSION,
  FORM_UPDATE_SUCCESS,
  FORM_UPDATE_FAILURE,

  // Errors
  ERROR_STATES,
  CLEAR_ERRORS,

  // Sessions
  SET_ACTIVE_SESSIONS,
  SET_SESSION_STATS,
  SET_SESSION_LOADING,

  // Security
  SET_SECURITY_METRICS,
  SET_SECURITY_LOADING,

  // Auth
  GET_LOGOUT,
});

export default ADMIN_ACTIONS;
